import ListThemes from './ListThemes';

//TODO: implement styled scrollbar
const List = ({ children, theme, className = '' }) => {
    const colorMapper = ListThemes[theme] || ListThemes.Light;
    return (
        <div
            className={`flex font-sf flex-col bg-${colorMapper.background} items-center text-13 w-50 px-2 py-2 ${className}`}>
            <div className="w-full overflow-x-hidden overflow-y-auto">{children}</div>
        </div>
    );
};

export default List;
